module.exports = __webpack_public_path__ + "img/T4-A-xh_12.9bd12b11.png";